import Layout from "../components/layout";
import Request from "../components/request";
import CodeExampleTabs from "../components/codeExampleTabs";
import Success from "../components/success";
import Alert from "../components/alert";
import Steps from "../components/steps";
import RequestParameters from "../components/models/requestParameters";
import {messageTimeout} from "../scripts/const";
import Overview from "../components/overview";
import Breadcrumb from "../components/breadcrumb";
import "../static/style/custom.css";
import FileParameter from "../components/models/fileParameter";
import DataBlock from "../components/dataBlock";
import * as Constants from "../scripts/const";
import {graphql} from "gatsby";
import {useTranslation} from "gatsby-plugin-react-i18next";
import downloadFile from "../scripts/downloadFile";
import SEO from "../components/seo";
import MethodFeatures from "../components/methodFeatures";
import MethodAdv from "../components/methodAdv";
import * as React from "react";
import PageTitle from "../components/pageTitle";

const RemoveAnnotationsPageTemplate = (props) => {
    const {t} = useTranslation();

    const pageTitle = t("remove-annotations-page-title");
    const title = t("remove-annotations-title").replaceAll("{0}");
    const description = t("remove-annotations-description");
    const apiUrl = process.env.PUBLIC_API_URL + "/removeAnnotations";

    const [files, setFiles] = React.useState([]);
    const [isAlertShown, setShowAlert] = React.useState(false);
    const [isSuccessShow, setShowSuccess] = React.useState(false);
    const [alertMessage, setAlertMessage] = React.useState("");
    const [isProcessing, setIsProcessing] = React.useState(false);

    React.useEffect(() => {
        setTimeout(function () {
            setShowSuccess(false)
            setShowAlert(false)
        }, messageTimeout);
    }, [isAlertShown, isSuccessShow])

    function errorHandler(message) {
        if (isAlertShown) return;
        setAlertMessage(message);
        setShowAlert(true)
    }

    function postButtonOnClickHandler() {
        if (files.length === 0) {
            errorHandler(t("fillAllRequiredFields"))
            return
        }

        if (isProcessing)
            return;

        setIsProcessing(true)
        const formData = new FormData();
        files.map(f => formData.append("document", f));

        fetch(apiUrl, {
                method: 'POST',
                body: formData
            }
        ).then(response => {
            if (response.ok) {
                setShowSuccess(true);
                downloadFile(response);
            } else {
                errorHandler(t("errorMessage"))
            }
        }).catch(_ => {
            errorHandler(t("errorMessage"))
        })
            .finally(() => setIsProcessing(false))
    }

    return (
        <>
            <SEO title={pageTitle} description={description}/>
            <Layout>
                {isSuccessShow && <Success/>}
                {isAlertShown && <Alert>{alertMessage}</Alert>}
                <Breadcrumb crumbs={props.pageContext.breadcrumb.crumbs}/>
                <PageTitle title={title} description={description}/>
                <div className="d-flex flex-nowrap p-relative container">
                    <div className="main py-4" id="main">
                        <div className="method-content d-flex flex-column w-100">
                            <Request value={apiUrl} onButtonClick={postButtonOnClickHandler} isProcessing={isProcessing}/>
                            <DataBlock title="document">
                                <RequestParameters>
                                    <FileParameter type="FormFile"
                                                   parameter="document"
                                                   description={t("document")}
                                                   isMultipart={false} files={files.map(f => f.name)}
                                                   onChange={setFiles} required={true}
                                                   errorHandler={errorHandler}
                                                   formats={Constants.presentationFormats}/>
                                </RequestParameters>
                            </DataBlock>
                            <CodeExampleTabs feature="removeAnnotations"
                                             request={
                                                 {
                                                     files: files.map(x => x.name),
                                                     url: apiUrl
                                                 }}/>
                            <MethodFeatures/>
                            <hr className="text mt-5"/>
                            <Overview/>
                            <Steps/>
                            <MethodAdv/>
                        </div>
                    </div>
                </div>
            </Layout>
        </>);
}

export default RemoveAnnotationsPageTemplate;

export const query = graphql`
  query($language: String!) {
    locales: allLocale(filter: {ns: {in: ["method", "properties", "header_footer", "crumbs"]}, language: {eq: $language}}) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;